module.exports = __webpack_public_path__ + "static/media/three.3df59c51.svg";